
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const invoiceService = {
    getInvoiceData,
    saveTableHeader,
    invoiceBulkAction,
    getInvoiceDetails,
    submitInvoice,
    getInvoiceByDate,
    downloadInvoicePdf
    
 
};

async function  getInvoiceData() {
    return  apiClient.get(`/invoices/get-invoice-data`, authHeader());
}


async function  getInvoiceByDate(date) {
    return  apiClient.put(`/invoices/get-invoice-by-date`, date, authHeader());
}

async function  invoiceBulkAction(body ) {
    return  apiClient.put(`/invoices/invoice-bulk-action`,body, authHeader());
}


async function  saveTableHeader(body) {
    return  apiClient.post(`/invoices/save-table-header`, body, authHeader());
}

async function  getInvoiceDetails(invoice_id) {
    return  apiClient.get(`/invoices/get-invoice-details/${invoice_id}`, authHeader());
}

async function  submitInvoice(data) {
    return  apiClient.post(`/invoices/submit-invoice`,data, authHeader());
}

async function  downloadInvoicePdf(invoice_id) {
    return  apiClient.get(`/invoices/download-invoice-pdf/${invoice_id}`, { ...authHeader(), responseType: 'blob' });
}







